export default "__VITE_ASSET__C98YhTIk__"